<svg
  [attr.viewBox]="'0 0 ' + SIZE + ' ' + SIZE"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="inputSize"
  [attr.height]="inputSize"
  [attr.colors]="colors"
  [attr.name]="name"
  [attr.size]="inputSize"
>
  <mask id="mask__sunset" maskUnits="userSpaceOnUse" x="0" y="0" [attr.width]="SIZE" [attr.height]="SIZE">
    <circle [attr.cx]="SIZE / 2" [attr.cy]="SIZE / 2" [attr.r]="SIZE / 2" fill="white" />
  </mask>
  <g mask="url(#mask__sunset)">
    <path [attr.fill]="'url(#gradient_paint0_linear_' + gradientId + ')'" d="M0 0h80v40H0z" />
    <path [attr.fill]="'url(#gradient_paint1_linear_' + gradientId + ')'" d="M0 40h80v40H0z" />
  </g>
  <defs>
    <linearGradient
      [attr.id]="'gradient_paint0_linear_' + gradientId"
      [attr.x1]="SIZE / 2"
      y1="0"
      [attr.x2]="SIZE / 2"
      [attr.y2]="SIZE / 2"
      gradientUnits="userSpaceOnUse"
    >
      <stop [attr.stop-color]="properties[0].color" />
      <stop offset="1" [attr.stop-color]="properties[1].color" />
    </linearGradient>
    <linearGradient
      [attr.id]="'gradient_paint1_linear_' + gradientId"
      [attr.x1]="SIZE / 2"
      [attr.y1]="SIZE / 2"
      [attr.x2]="SIZE / 2"
      [attr.y2]="SIZE"
      gradientUnits="userSpaceOnUse"
    >
      <stop [attr.stop-color]="properties[2].color" />
      <stop offset="1" [attr.stop-color]="properties[3].color" />
    </linearGradient>
  </defs>
</svg>
